module.exports = __webpack_public_path__ + "static/lifespan-a38faca955e1eeab0bcce7b72d0df20c.jpg";